export const useViewPersistence = (map: Ref<google.maps.Map | undefined>) => {
  const lastView = useSessionStorage<DashboardMapView>("map-last-view-gmap", {
    initialized: false,
    coordinates: { lat: 0, lng: 0 },
    zoom: 14,
  })

  const updateSessionWithCurrentView = () => {
    if (!map.value) return

    if (!lastView.value.initialized) {
      lastView.value.initialized = true
    }

    const center = map.value.getCenter()
    if (center) {
      // Update the local storage with the current center
      lastView.value.coordinates = { lat: center.lat(), lng: center.lng() }
    }

    // Update the local storage with the new zoom level
    lastView.value.zoom = map.value.getZoom() ?? 14
  }

  const goToLastView = (): boolean => {
    if (!map.value) return false

    if (!lastView.value.initialized || (lastView.value.coordinates.lat === 0 && lastView.value.coordinates.lng === 0)) return false

    const targetZoom = lastView.value.zoom
    const targetCoordinates = lastView.value.coordinates

    map.value.setZoom(targetZoom)
    map.value.panTo(targetCoordinates)

    return true
  }

  const initializeViewPersistence = () => {
    if (!map.value) {
      throw new Error("Map is not initialized")
    }

    map.value.addListener("dragend", () => updateSessionWithCurrentView())
    map.value.addListener("zoom_changed", () => updateSessionWithCurrentView())
  }

  return {
    initializeViewPersistence,
    goToLastView,
  }
}
